import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '../../../../../../_metronic/helpers'
import { getFaturaById } from '../../faturas-list/core/_requests'
import { getFaturaByEmpresa } from '../../faturas-responsavel-list/core/_requests'

/**
 * Fatura da rota (`:idFatura`, e `:idEmpresa` na visão do responsável da instituição). Em cache
 * pela chave: o resumo do topo e as ações das linhas (que dependem da situação) dividem a
 * mesma requisição.
 */
export const useFaturaAtual = () => {
  const { idFatura, idEmpresa } = useParams<{ idFatura: string; idEmpresa?: string }>()

  const {
    data: fatura,
    isLoading,
    refetch,
  } = useQuery(
    ['fatura-atual', idFatura, idEmpresa],
    () =>
      idEmpresa
        ? getFaturaByEmpresa(Number(idEmpresa), Number(idFatura))
        : getFaturaById(Number(idFatura)),
    { enabled: Boolean(idFatura), refetchOnWindowFocus: false, onError: showError }
  )

  return { fatura, isLoading, refetch, idFatura: Number(idFatura), idEmpresa }
}
